import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICompanyType } from "src/models/Stores/Company.models";

interface CompanyTypeState {
    companyTypes: ICompanyType[];
    companyTypeToEdit: ICompanyType | null;
}

const initialState: CompanyTypeState = {
    companyTypes: [],
    companyTypeToEdit: null,
};

const companyTypeSlice = createSlice({
    name: "CompanyType",
    initialState,
    reducers: {
        setCompanyTypeList: (state, action: PayloadAction<ICompanyType[]>) => {
            state.companyTypes = action.payload;
        },
        concatListCompanyType: (
            state: CompanyTypeState,
            action: PayloadAction<ICompanyType[]>
        ) => {
            state.companyTypes = [...state.companyTypes.concat(action.payload)];
        },
        setCompanyTypeToEdit: (state, action: PayloadAction<ICompanyType | null>) => {
            state.companyTypeToEdit = action.payload;
        },
        addCompanyType: (state, action: PayloadAction<ICompanyType>) => {
            state.companyTypes.push(action.payload);
        },
        updateCompanyType: (state, action: PayloadAction<ICompanyType>) => {
            let itemIndex = state.companyTypes.findIndex(
                item => item.companyTypeId === action.payload.companyTypeId
            );
            if (itemIndex !== -1) state.companyTypes[itemIndex] = action.payload;
        },
        deleteCompanyType: (state, action: PayloadAction<string>) => {
            const newArray = state.companyTypes.filter(
                item => item.companyTypeId !== action.payload
            );
            state.companyTypes = newArray;
        },
    },
});

export const {
    setCompanyTypeList,
    concatListCompanyType,
    setCompanyTypeToEdit,
    addCompanyType,
    updateCompanyType,
    deleteCompanyType
} = companyTypeSlice.actions;

export default companyTypeSlice.reducer;